import { CSSProperties } from "@material-ui/core/styles/withStyles";
import { greys, colors } from "@clockwise/web-commons/src/styles/color.styles";
import spacing from "@clockwise/web-commons/src/styles/spacing.styles";
import { CHROME_MAX_WIDTH } from "@components/chrome-wrapper/ChromeWrapper.styles";

export const container: CSSProperties = {
  height: `calc(100% - 112px)`,
  overflowY: "scroll",
  overflowX: "hidden",
};

export const eventTitle: CSSProperties = {
  paddingBottom: spacing.sm,
};

export const divider: CSSProperties = {
  width: "100%",
  // position: 'absolute',
  left: 0,
  backgroundColor: greys.paleGrey,
};

export const buttonContainer: CSSProperties = {
  position: "fixed",
  width: CHROME_MAX_WIDTH,
  bottom: 0,
  zIndex: 1,
  background: greys.white,
  marginLeft: -10,
  padding: `${spacing.std}px ${spacing.sm}px ${spacing.std}px ${spacing.sm}px`,
  boxShadow: "rgba(0, 0, 0, 0.25) 0px 0px 1px",
};

export const primaryBtn: CSSProperties = {
  background: colors.green.standard,
  boxShadow: "none",
};

const secondaryBtn: CSSProperties = {
  marginTop: 10,
  background: greys.paleGrey,
};

export const styles = {
  primaryBtn,
  secondaryBtn,
};
